module.exports = __webpack_public_path__ + "img/cju_gallery1.81fa559b.jpg";